// extracted by mini-css-extract-plugin
module.exports = {"container":"_1NPGfst5zgEyq8yeg0upmj","groupsList":"_36ZUBHYTos3w3zZA7RQd6t"};